import tw, { styled } from 'twin.macro';

export const TextItemContainer = styled.div`
  ${tw`flex flex-col justify-start`};
  ${tw`lg:col-span-5`}
  ${tw`md:container`}

  &:nth-of-type(even) {
    ${tw`lg:col-start-7`}
  }
`;
